<app-dialog
    [title]="data.title"
    (close)="close()">
    <ng-container dialogContent>
        <ng-container *ngIf="isLoadTree | async; else preloaderTemplate">
            <div cdkDropListGroup
                 class="settings-table-container flex-row lt-md:flex-col">
                <div class="basis-full data-card-container">
                    <mat-card class="h-full" #scrollableContainerAll>
                        <mat-card-header fxLayoutAlign="flex-start center" class="sticky top-0 z-10">
                            <mat-card-title>
                                {{appService.language_dictionary.system_settings_table_dialog_all}}
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <app-input-search
                                class="sticky top-[40px] z-10"
                                (inputEvent)="filterService(dataAll, $event, 'all')"
                                [showToggleArrowButtons]="true"
                                [disableDown]="filterState.all.disableDown"
                                [disableUp]="filterState.all.disableUp"
                                [label]="appService.language_dictionary.input_search_placeholder"
                                (switching)="switchRowInFilteredData($event, 'all')">
                            </app-input-search>
                            <mat-tree id="fields-tree"
                                      [dataSource]="dataSourceAll"
                                      [treeControl]="treeControlAll"
                                      cdkDropList
                                      cdkDropListSortingDisabled
                                      cdkDropListConnectedTo="table-fields-tree"
                                      class="settings-table-tree">
                                <mat-tree-node *matTreeNodeDef="let node; when: firstLevel">
                                    <li class="w-full">
                                        <div class="mat-tree-node mat-tree-node-parent">
                                            <button mat-icon-button matTreeNodeToggle
                                                    [attr.aria-label]="'toggle ' + node.name">
                                                <mat-icon
                                                    aria-hidden="true"
                                                    class="mat-icon-rtl-mirror" *ngIf="hasChild(node) | async">
                                                    {{treeControlAll.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                                </mat-icon>
                                            </button>
                                            {{node.name}}
                                        </div>
                                    </li>
                                </mat-tree-node>
                                <mat-tree-node *matTreeNodeDef="let node"
                                               #itemRefDataAll
                                               matTreeNodeToggle
                                               data-id="{{node.alias}}"
                                               [class.focused-node]="activeNode === node.alias"
                                               cdkDrag
                                               [cdkDragData]="node">
                                    <li class="mat-tree-node">
                                        <button mat-icon-button disabled></button>
                                        <span class="mat-tree-node-item"
                                              [highlight]="highlightText.all"
                                              [text]="node.name"
                                              [customClass]="'light-id'">{{node.name}}</span>
                                        <fui-button
                                            (clickEvent)="moveNodeBetweenTree(this.dataAll, this.dataSelected, node)"
                                            [title]="appService.language_dictionary.system_add"
                                            [type]="'button-icon'"
                                            [icon]="'plus-circle-outline'"
                                            [height]="'slim'"
                                            [color]="'flat'"
                                            [borderRadius]="'circle'"
                                            [iconSize]="14">
                                        </fui-button>
                                    </li>
                                </mat-tree-node>
                            </mat-tree>
                        </mat-card-content>
                    </mat-card>
                </div>
                <div class="basis-full table-fields">
                    <mat-card class="h-full"
                              #scrollableContainerSelect cdkScrollable>
                        <mat-card-header fxLayoutAlign="flex-start center" class="sticky top-0 z-10">
                            <mat-card-title>
                                {{appService.language_dictionary.system_settings_table_dialog_select}}
                            </mat-card-title>
                        </mat-card-header>
                        <mat-card-content>
                            <app-input-search
                                #appInputSearch
                                class="sticky top-[40px] z-10"
                                (inputEvent)="filterService(dataSelected, $event, 'select')"
                                [showToggleArrowButtons]="true"
                                [disableDown]="filterState.select.disableDown"
                                [disableUp]="filterState.select.disableUp"
                                (switching)="switchRowInFilteredData($event, 'select')"
                                [label]="appService.language_dictionary.input_search_placeholder">
                            </app-input-search>
                            <mat-tree id="table-fields-tree"
                                      [dataSource]="dataSourceSelect"
                                      [treeControl]="treeControlSelect"
                                      class="settings-table-tree mat-tree-selected h-full"
                                      cdkDropList
                                      (cdkDropListDropped)="drop($event)">
                                <mat-nested-tree-node
                                    class="mat-tree-node"
                                    data-id="{{node.alias}}"
                                    #itemRefDataSelect
                                    [class.focused-node]="activeNode === node.alias"
                                    *matTreeNodeDef="let node; when: secondLevel"
                                    cdkDrag
                                    [cdkDragData]="node"
                                    cdkDragBoundary="#table-fields-tree"
                                    (cdkDragStarted)="dragStart()"
                                    (cdkDragReleased)="dragEnd()">
                                    <mat-checkbox
                                        disableRipple="true"
                                        *ngIf="node.columns.length == 0"
                                        class="mat-tree-node-item"
                                        [matTooltip]="node.name?.length > 40 ? node.name : ''"
                                        [(ngModel)]="nodeCheckbox[node.alias]"
                                        value="{{node.name}}">
                                    <span
                                        [highlight]="highlightText.select"
                                        [text]="node.name"
                                        [customClass]="'light-id'">
                                    {{node.name | truncate: 40}}
                                </span>
                                    </mat-checkbox>
                                    <div
                                        class="action"
                                        [class.w-full]="node.isUnion"
                                        [class.flex]="node.isUnion"
                                        [class.items-center]="node.isUnion">
                                        <div class="mat-tree-node-item" *ngIf="node.columns.length > 1">
                                            <span class="mat-tree-node-item-label">{{node.name}}</span>
                                        </div>
                                        <div class="mat-tree-node-icon" *ngIf="node.is_main">
                                            <i class="mdi mdi-star"></i>
                                        </div>
                                        <div class="mat-tree-node-icon" *ngIf="node.is_sticky">
                                            <i class="mdi mdi-pin-outline"></i>
                                        </div>
                                        <fui-button
                                            (clickEvent)="moveNodeBetweenTree(dataSelected, dataAll, node)"
                                            [title]="appService.language_dictionary.system_remove_input"
                                            [type]="'button-icon'"
                                            [icon]="'minus-circle-outline'"
                                            [height]="'slim'"
                                            [color]="'flat'"
                                            [borderRadius]="'circle'"
                                            [iconSize]="14"
                                            [disabled]="data.settings.select.length < 2">
                                        </fui-button>
                                        <fui-button
                                            [matMenuTriggerFor]="settingsTableMenu"
                                            [title]="appService.language_dictionary.system_actions"
                                            [type]="'button-icon'"
                                            [icon]="'dots-vertical'"
                                            [height]="'slim'"
                                            [color]="'flat'"
                                            [borderRadius]="'circle'"
                                            [iconSize]="14">
                                        </fui-button>
                                    </div>
                                    <mat-menu
                                        #settingsTableMenu="matMenu"
                                        classList="setting-table-mat-menu-rounded-bottom">
                                        <button
                                            mat-menu-item
                                            class="settings-table-mat-menu-item"
                                            (click)="openNameDialog('rename', node, [])">
                                            <i class="mdi mdi-pencil-outline mat-icon"></i>
                                            {{appService.language_dictionary.system_rename}}
                                        </button>
                                        <button
                                            mat-menu-item
                                            class="settings-table-mat-menu-item"
                                            (click)="moveNode(node, true)">
                                            <i class="mdi mdi-arrow-up mat-icon"></i>
                                            {{appService.language_dictionary.system_up}}
                                        </button>
                                        <button
                                            mat-menu-item
                                            class="settings-table-mat-menu-item"
                                            (click)="moveNode(node, false)">
                                            <i class="mdi mdi-arrow-down mat-icon"></i>
                                            {{appService.language_dictionary.system_way_down}}
                                        </button>
                                        <button mat-menu-item class="settings-table-mat-menu-item"
                                                *ngIf="!node.is_sticky"
                                                (click)="node.is_sticky = true">
                                            <i class="mdi mdi-pin-outline mat-icon"></i>
                                            {{appService.language_dictionary.system_to_fix}}
                                        </button>
                                        <button mat-menu-item class="settings-table-mat-menu-item"
                                                *ngIf="node.is_sticky"
                                                (click)="node.is_sticky = false">
                                            <i class="mdi mdi-pin mat-icon"></i>
                                            {{appService.language_dictionary.system_unpin}}
                                        </button>
                                        <button mat-menu-item *ngIf="!node.is_main"
                                                (click)="setMainColumn(node)"
                                                class="settings-table-mat-menu-item">
                                            <i class="mdi mdi-star mat-icon"></i>
                                            {{appService.language_dictionary.system_make_main}}
                                        </button>
                                        <button mat-menu-item *ngIf="node.is_main"
                                                (click)="node.is_main = false"
                                                class="settings-table-mat-menu-item">
                                            <i class="mdi mdi-star-outline mat-icon"></i>
                                            {{appService.language_dictionary.system_make_minor}}
                                        </button>
                                        <button mat-menu-item *ngIf="node.columns.length == 0"
                                                [disabled]="hasNodeCheckboxChecked()"
                                                class="settings-table-mat-menu-item"
                                                (click)="unionNode()">
                                            <i class="mdi mdi-vector-union mat-icon"></i>
                                            {{appService.language_dictionary.system_combine}}
                                        </button>
                                        <button mat-menu-item *ngIf="node.columns.length > 1"
                                                class="settings-table-mat-menu-item"
                                                (click)="unUnionNode(node)">
                                            <mat-icon aria-hidden="true">link</mat-icon>
                                            {{appService.language_dictionary.system_disconnect}}
                                        </button>
                                    </mat-menu>
                                </mat-nested-tree-node>
                            </mat-tree>
                            <ng-container
                                *ngIf="dataSourceSelect.data.length === 0 && (appInputSearch.searchStr$ | async)?.length > 0">
                                <div
                                    class="grow flex flex-col items-center justify-center leading-[80px] text-[#bdbdbd]">
                                    <mat-icon
                                        aria-hidden="true"
                                        class="icon-80"
                                        fontSet="mdi"
                                        fontIcon="mdi-text-box-search">
                                    </mat-icon>
                                    <div>
                                        {{appService.language_dictionary.rubricator_search_empty}}
                                    </div>
                                </div>
                            </ng-container>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </ng-container>
        <ng-template #preloaderTemplate>
            <div class="flex flex-row gap-[8px] w-full lt-sm:flex-col">
                <ng-container *ngFor="let item of [1,2]">
                    <div class="basis-full lt-sm:basis-auto">
                        <div class="flex flex-col gap-y-[8px]">
                            <ng-container *ngFor="let item of [1,2]">
                                <ngx-skeleton-loader
                                    count="1" appearance="line" SkeletonLoader
                                    [theme]="skeletonConf">
                                </ngx-skeleton-loader>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-template>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            [label]="appService.language_dictionary.system_save"
            [icon]="'content-save'"
            [height]="'mini'"
            (clickEvent)="save()">
        </fui-button>
        <fui-button
            [label]="appService.language_dictionary.system_cancel"
            [color]="'light'"
            [icon]="'close'"
            [height]="'mini'"
            (clickEvent)="close()">
        </fui-button>
        <fui-button
            *ngIf="data.tableService"
            [matMenuTriggerFor]="menuTopPager"
            [title]="appService.language_dictionary.system_actions"
            [color]="'light'"
            [type]="'button-icon'"
            [icon]="'dots-vertical'"
            [height]="'mini'">
        </fui-button>
        <mat-menu
            #menuTopPager="matMenu">
            <button
                mat-menu-item
                type="button"
                class="settings-table-mat-menu-item"
                (click)="clearTableSettings()">
                {{appService.language_dictionary.system_reset_table_settings}}
            </button>
        </mat-menu>
    </ng-container>
</app-dialog>
